// Import css modules
import "../css/main.scss";
import MagneticCover from "./magnetic-cover";

const revueCover = new MagneticCover(
  document.body.querySelector(".revue-cover__img"),
  document.body.querySelector(".revue-cover__trails")
);
